
import Component from 'vue-class-component';
import Slots from '../model/templating/Slots';
import Base from './Base.vue';

@Component({
  name: 'render',
})
export default class Render extends Base {
  get slots(): Slots {
    if (this.template?.slots) return this.template.slots;
    return {};
  }

  // Doit être override pour éviter le double appel à l'event si configuré
  // callDone() {
  //   if (isFunction(this.$parent.callDone)) this.$parent.callDone(this);
  // }
}
